import { render, staticRenderFns } from "./blogs_rightside.vue?vue&type=template&id=66a75c55"
import script from "./blogs_rightside.vue?vue&type=script&lang=js"
export * from "./blogs_rightside.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports